import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantInventoryItems, tenantInventoryStockLevels } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

/**
 * Unpaginated item list (page 1, limit 1000) for joins and ComboBoxes: the paginated
 * hook only ever holds page 1, so items beyond it lose their names/units and vanish
 * from form selection. The items TABLE page itself has moved onto @restavo/crud
 * (src/features/inventoryItems), which owns its own paginated query and filters.
 */
export const useAllInventoryItems = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery(
    [QUERIES.INVENTORY_ITEMS_ALL, orgSlug, restaurantId],
    () => tenantInventoryItems({ orgSlug, restaurantId }, { page: 1, limit: 1000 }),
    { cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false }
  );
};

/**
 * Stock is a per-branch balance. The route is restaurant-scoped, so the branch rides along
 * as a query param — without it the table would show cross-branch totals while the movement
 * form rejects against the branch balance.
 */
export const useInventoryStockLevels = () => {
  const { orgSlug, restaurantId, branchId } = useTenantContext();
  return useQuery(
    [QUERIES.INVENTORY_STOCK_LEVELS, orgSlug, restaurantId, branchId],
    () => tenantInventoryStockLevels({ orgSlug, restaurantId }, branchId ? { branchId } : undefined),
    { cacheTime: 0, refetchOnMount: true, refetchOnWindowFocus: false }
  );
};
